import { gql } from '@apollo/client';

export const GET_LOANS_QUERY = gql`
  query GetLoansByAssetClass($assetClass: String!, $offset: Int!) {
    user {
      id
      company {
        id
        loans(
          sort: { sort_field: account_id, sort_direction: asc }
          pagination: { page_size: 100, offset: $offset }
          filters: [{ field_name: asset_class, operator: IS, operand: $assetClass }]
        ) {
          id
          account_id
        }
      }
    }
  }
`;
